import React, { useState } from 'react';
import { uuid } from 'uuidv4';
import moment from 'moment'; // Global States for faster scheduling

import { useStore } from "../../contexts/store";
import { sendMetric } from '@atheneum/api/dist/lib'; // Components

import RenderClientAction from "../RenderClientAction";
import RenderExpertAction from "../RenderExpertAction";
import createAvailability from "../../helpers/zoomHelpers/createAvailability";
import formatDateTime from "../../helpers/zoomHelpers/formatDateTime";
import getTime from "../../helpers/zoomHelpers/getTime";
import { addHoursAndMinutesInMs } from "../../helpers/zoomHelpers";
import formatExpertInvite from "../../helpers/expertHelpers";
import clientEmailTemplateTypeOfNone from "../../helpers/initializeHelpers/emailTemplates/clientEmailTemplateTypeOfNone";
import clientEmailTemplate from "../../helpers/initializeHelpers/emailTemplates/clientEmailTemplate";
import expertEmailTemplate from "../../helpers/initializeHelpers/emailTemplates/expertEmailTemplate";
import { getEmailTemplateByGroup } from "../../api";
import "./style.css";

const ZoomContainer = ({
  growlStore,
  multiAction
}) => {
  const {
    state,
    dispatch
  } = useStore();
  const {
    firstMatch,
    quickInviteExpert,
    schedule,
    // TODO: should just use availabilityStore form mobx
    availabilityStore_imp: availabilityStore,
    quickInviteClient,
    currentPath,
    timeOnDrop,
    duration,
    sendZoomUpdate,
    dayToRender,
    takenExpertSlots,
    expertMessage,
    zoomNum,
    employeeSubmitted,
    selectedLanguage,
    expertCountry,
    expertTimezoneName,
    timezoneTranslated,
    meetingType,
    expertInvited,
    clientInvited,
    languageUpdated,
    templateId,
    previouslySendLanguage,
    clientTitle,
    expertInfo,
    userPosition,
    userPhoneNumbers,
    previouslySend,
    connectedZoomMeeting,
    mcKinseyTemplates,
    mcKinseyMessage,
    expertDayOffset,
    showExpertCountry
  } = state;
  const {
    epl: eplFromAvailabilityStore,
    persistedScheduleInfo
  } = availabilityStore;
  const [currentDuration, setCurrentDuration] = useState(duration);

  const setupQuickInvite = checkUpdates => {
    const selectedStartDate = currentPath === 'overview' ? new Date(parseInt(firstMatch.toString())).setHours(0, 0, 0, 0) : new Date(parseInt(dayToRender.format('x'))).setHours(0, 0, 0, 0);
    const {
      hourStart,
      minutesStart,
      hourEnd,
      minutesEnd
    } = currentPath === 'overview' ? getTime(schedule.timeslots[0].time.start, duration) : getTime();
    const startTimes = takenExpertSlots.map(slot => parseInt(moment(slot.startTime).format('x')));
    const endTimes = takenExpertSlots.map(slot => parseInt(moment(slot.endTime).format('x')));
    const start = addHoursAndMinutesInMs(selectedStartDate, hourStart, minutesStart);
    const end = addHoursAndMinutesInMs(selectedStartDate, hourEnd, minutesEnd);
    const startTimeCheck = startTimes.every(startTime => {
      return start <= startTime && end > startTime;
    });
    const endTimesCheck = endTimes.every(endTime => {
      return start < endTime && end >= endTime;
    });
    const freeSlot = !startTimeCheck && !endTimesCheck; // Data validation

    if (start <= new Date().getTime()) {
      growlStore.showError('Select a time slot past the current time', 'Error: Cannot schedule in the past!');
      sendMetric('scheduling.ScheduleInPast', 'scheduling', {
        status: 'error'
      });
      return;
    }

    if (takenExpertSlots.length && !freeSlot) {
      sendMetric('scheduling.SlotTaken', 'scheduling', {
        status: 'error'
      });
      growlStore.showError('Slot is already taken for this expert.');
      return;
    }

    const updateObj = {
      sendZoomUpdate: true,
      callJoinUrl: 'Url will be created after confirm',
      zoomMeetingIdToAttach: 0
    };

    if (currentPath === 'calendarview') {
      const newTimeslot = {
        duration: duration,
        id: uuid(),
        time: {
          start,
          end
        },
        drafts: []
      };
      const nTS = {
        timeslots: [newTimeslot]
      };
      updateObj.nTS = nTS;
      updateObj.expertMessage = formatExpertInvite(expertMessage, nTS, availabilityStore, zoomNum, employeeSubmitted, selectedLanguage, expertCountry, expertTimezoneName, timezoneTranslated, languageUpdated, templateId, previouslySendLanguage, expertDayOffset, showExpertCountry);

      if (checkUpdates) {
        dispatch({
          type: 'SETSCHEDULE',
          payload: {
            schedule: { ...schedule,
              timeslots: [newTimeslot],
              availabilities: [...schedule.availabilities, ...createAvailability(newTimeslot, duration)]
            }
          }
        });
      } else {
        updateObj.tempSchedule = { ...schedule,
          timeslots: [newTimeslot],
          availabilities: [...schedule.availabilities, ...createAvailability(newTimeslot, duration)]
        };
      }
    } else {
      if (checkUpdates) {
        updateObj.quick = true;
      }
    }

    if (checkUpdates) {
      if (quickInviteExpert && !expertInvited) {
        updateObj.quickUpdateExpert = quickInviteExpert;
        updateObj.expertinviteEdited = 'expert';
      }

      if (quickInviteClient && !clientInvited) {
        updateObj.quickUpdateClient = quickInviteClient;
        updateObj.clientinviteEdited = 'client';
      }
    }

    dispatch({
      type: 'UPDATE',
      payload: updateObj
    });
  };

  const haveZoomMeeting = persistedScheduleInfo && !!persistedScheduleInfo.zoomMeetingId && !!persistedScheduleInfo.zoomMeeting;
  const updating = !!timeOnDrop && !!timeOnDrop.length && timeOnDrop !== formatDateTime(schedule.timeslots.length ? schedule.timeslots[0].time.start : firstMatch); // Move all these logics to when submitedNewSchedule become true

  const connectedExperts = !!connectedZoomMeeting && !!connectedZoomMeeting.length ? connectedZoomMeeting.filter(meeting => meeting.expertNames.includes(eplFromAvailabilityStore.expert.fullName)).map(meeting => meeting.expertNames.split(', ').filter(experts => !experts.includes(eplFromAvailabilityStore.expert.fullName)))[0] : [];

  const Quick = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: "request-schedule__invite-action_NEW mw0",
      onClick: () => {
        if (!multiAction && !!connectedExperts && !!connectedExperts.length) {
          sendMetric('scheduling.LongErrorMultipleExperts', 'scheduling', {
            status: 'error'
          });
          return growlStore.showError(`This schedule is sharing Zoom meeting with other experts, so it cant be updated. <br/>
            To reschedule this call:<br/>
            1. remove existing schedule and confirm <br/>
            2. then create new schedule and Zoom meeting <br/>
            <strong>Or</strong><br/>
            Reschedule all EPLs in the meeting at once by clicking on the three dots in the top right corner of the multi Expert container
            `);
        }

        dispatch({
          type: 'UPDATE',
          payload: {
            onQuick: true
          }
        });
        setCurrentDuration(duration);
        setupQuickInvite(true);
      }
    }, "Quick");
  };

  const Custom = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: "request-schedule__invite-action_NEW mw0",
      onClick: () => {
        setCurrentDuration(duration);
        setupQuickInvite(false);
        dispatch({
          type: 'UPDATE',
          payload: {
            lastPath: currentPath,
            currentPath: 'createZoom',
            onCustom: true
          }
        });
      }
    }, "Custom");
  };

  const Modify = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: "request-schedule__invite-action_NEW mw0",
      onClick: () => {
        setCurrentDuration(duration);
        dispatch({
          type: 'UPDATE',
          payload: {
            lastPath: currentPath,
            currentPath: 'quickEdit'
          }
        });
      }
    }, "Modify");
  };

  const updateForNoneType = async (start, end) => {
    const responseTemplates = await getEmailTemplateByGroup('schedule_invite_no_honorarium_free');

    if (!!previouslySend && (previouslySend.includes('zoom') || previouslySend.includes('Zoom'))) {
      dispatch({
        type: 'UPDATE',
        payload: {
          typeUpdated: true
        }
      });
    } else if (!!previouslySend) {
      dispatch({
        type: 'UPDATE',
        payload: {
          typeUpdated: false
        }
      });
    }

    const newTimeslot = {
      duration: duration,
      id: uuid(),
      time: {
        start,
        end
      },
      drafts: []
    };
    const nTS = {
      timeslots: [newTimeslot]
    };
    dispatch({
      type: 'UPDATE',
      payload: {
        expertMessage: schedule.timeslots.length ? formatExpertInvite(responseTemplates.filter(d => d.name.toLowerCase().includes(selectedLanguage))[0].content, !!schedule.timeslots.length ? schedule : nTS, availabilityStore, zoomNum, employeeSubmitted, selectedLanguage, expertCountry, expertTimezoneName, timezoneTranslated, languageUpdated, templateId, previouslySendLanguage, expertDayOffset, showExpertCountry) : responseTemplates.filter(d => d.name.toLowerCase().includes(selectedLanguage))[0].content,
        clientMessage: clientEmailTemplateTypeOfNone(clientTitle, expertInfo, availabilityStore, userPosition, userPhoneNumbers),
        renderSpinner: false,
        templates: responseTemplates
      }
    });
  };

  const updateForZoomType = async (start, end) => {
    dispatch({
      type: 'UPDATE',
      payload: {
        clientMessage: clientEmailTemplate(clientTitle, expertInfo, availabilityStore, userPosition, userPhoneNumbers),
        quickUpdateClient: true
      }
    });
    const {
      templates
    } = await expertEmailTemplate(null, eplFromAvailabilityStore.honorarium);

    if (!!previouslySend && (!previouslySend.includes('zoom') || !previouslySend.includes('Zoom'))) {
      dispatch({
        type: 'UPDATE',
        payload: {
          typeUpdated: true
        }
      });
    } else if (!!previouslySend) {
      dispatch({
        type: 'UPDATE',
        payload: {
          typeUpdated: false
        }
      });
    }

    const newTimeslot = {
      duration: duration,
      id: uuid(),
      time: {
        start,
        end
      },
      drafts: []
    };
    const nTS = {
      timeslots: [newTimeslot]
    };
    dispatch({
      type: 'UPDATE',
      payload: {
        expertMessage: formatExpertInvite(templates.filter(d => d.name.toLowerCase().includes(selectedLanguage))[0].content, !!schedule.timeslots.length ? schedule : nTS, availabilityStore, zoomNum, employeeSubmitted, selectedLanguage, expertCountry, expertTimezoneName, timezoneTranslated, languageUpdated, templateId, previouslySendLanguage, expertDayOffset, showExpertCountry),
        clientMessage: clientEmailTemplate(clientTitle, expertInfo, availabilityStore, userPosition, userPhoneNumbers),
        renderSpinner: false,
        templates: templates
      }
    });
  };

  const updateForMckinseyType = async (start, end) => {
    dispatch({
      type: 'UPDATE',
      payload: {
        clientMessage: clientEmailTemplate(clientTitle, expertInfo, availabilityStore, userPosition, userPhoneNumbers)
      }
    });

    if (!!mcKinseyTemplates) {
      dispatch({
        type: 'UPDATE',
        payload: {
          templates: mcKinseyTemplates,
          expertMessage: mcKinseyMessage,
          renderSpinner: false
        }
      });
      return;
    } else {
      dispatch({
        type: 'UPDATE',
        payload: {
          quickUpdateClient: true,
          meetingType: 'mcKinsey'
        }
      });
      const {
        templates
      } = await expertEmailTemplate(null, eplFromAvailabilityStore.honorarium);

      if (!!previouslySend && (!previouslySend.includes('mcKinsey') || !previouslySend.includes('mcKinsey'))) {
        dispatch({
          type: 'UPDATE',
          payload: {
            typeUpdated: true
          }
        });
      } else if (!!previouslySend) {
        dispatch({
          type: 'UPDATE',
          payload: {
            typeUpdated: false
          }
        });
      }

      const newTimeslot = {
        duration: duration,
        id: uuid(),
        time: {
          start,
          end
        },
        drafts: []
      };
      const nTS = {
        timeslots: [newTimeslot]
      };
      dispatch({
        type: 'UPDATE',
        payload: {
          expertMessage: formatExpertInvite(templates.filter(d => d.name.toLowerCase().includes(selectedLanguage))[0].content, !!schedule.timeslots.length ? schedule : nTS, availabilityStore, zoomNum, employeeSubmitted, selectedLanguage, expertCountry, expertTimezoneName, timezoneTranslated, languageUpdated, templateId, previouslySendLanguage, expertDayOffset, showExpertCountry),
          templates: templates,
          clientMessage: clientEmailTemplate(clientTitle, expertInfo, availabilityStore, userPosition, userPhoneNumbers),
          renderSpinner: false
        }
      });
    }
  }; // Review: only call dispatch once and reduce if else conditions and run async await promise in parallel if possible


  const updateType = async e => {
    e.persist();
    const timeObj = currentPath === 'overview' ? getTime(schedule.timeslots[0].time.start, duration) : getTime();
    const {
      hourStart,
      minutesStart,
      hourEnd,
      minutesEnd
    } = timeObj;
    const selectedStartDate = currentPath === 'overview' ? new Date(parseInt(firstMatch.toString())).setHours(0, 0, 0, 0) : new Date(parseInt(dayToRender.format('x'))).setHours(0, 0, 0, 0);
    const start = addHoursAndMinutesInMs(selectedStartDate, hourStart, minutesStart);
    const end = addHoursAndMinutesInMs(selectedStartDate, hourEnd, minutesEnd);
    dispatch({
      type: 'UPDATE',
      payload: {
        renderSpinner: true,
        meetingType: e.target.value
      }
    });

    if (e.target.value === 'None') {
      await updateForNoneType(start, end);
    }

    if (e.target.value === 'Zoom') {
      await updateForZoomType(start, end);
    }

    if (e.target.value === 'mcKinsey') {
      await updateForMckinseyType(start, end);
    }
  };

  const formatTimeOnDrop = timeOnDrop => new Date(timeOnDrop.split('at')[0].replace(',', '') + timeOnDrop.split('at')[1].split(' ')[1]).getTime();

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__invite-info_FS"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__invite-item_NEW"
  }, /*#__PURE__*/React.createElement("div", null, "Type:", /*#__PURE__*/React.createElement("select", {
    id: "handleMeetingType",
    onChange: updateType,
    style: {
      height: '25px'
    },
    className: "selectMeetingType",
    value: meetingType
  }, /*#__PURE__*/React.createElement("option", {
    className: "selectMeetingType_",
    value: "Zoom"
  }, "Zoom"), /*#__PURE__*/React.createElement("option", {
    className: "selectMeetingType_",
    value: "mcKinsey"
  }, "McKinsey - API"), /*#__PURE__*/React.createElement("option", {
    className: "selectMeetingType_",
    value: "None"
  }, "None"))))), !haveZoomMeeting && !sendZoomUpdate && meetingType === 'Zoom' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__invite-item_NEW"
  }, /*#__PURE__*/React.createElement("div", {
    className: "editZoomInfo_wrapper"
  }, "Zoom meeting has not been created")), /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__invite-item_NEW"
  }, /*#__PURE__*/React.createElement("div", null, "Zoom Creation"), /*#__PURE__*/React.createElement("div", {
    className: "flexActions"
  }, /*#__PURE__*/React.createElement(Quick, null), /*#__PURE__*/React.createElement("span", {
    className: "m0-5"
  }, "|"), /*#__PURE__*/React.createElement(Custom, null), " ", /*#__PURE__*/React.createElement("br", null)))), sendZoomUpdate && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__invite-item_NEW"
  }, /*#__PURE__*/React.createElement("div", {
    className: "editZoomInfo_wrapper"
  }, meetingType === 'Zoom' ? 'Zoom' : 'Meeting', " is currently scheduled for \xA0", formatDateTime(schedule.timeslots.length ? schedule.timeslots[0].time.start : 0)), !updating && meetingType === 'Zoom' && /*#__PURE__*/React.createElement("div", {
    className: "flexActions"
  }, /*#__PURE__*/React.createElement(Modify, null)))), haveZoomMeeting && (updating || currentDuration !== duration) && meetingType === 'Zoom' && /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__invite-item_NEW"
  }, /*#__PURE__*/React.createElement("div", null, !!timeOnDrop.length && formatTimeOnDrop(timeOnDrop) !== schedule.timeslots[0].time.start ? /*#__PURE__*/React.createElement(React.Fragment, null, "Update meeting to", ' ', /*#__PURE__*/React.createElement("span", {
    className: "fw900"
  }, timeOnDrop)) : /*#__PURE__*/React.createElement(React.Fragment, null, " Update meeting ")), /*#__PURE__*/React.createElement("div", {
    className: "flexActions"
  }, /*#__PURE__*/React.createElement(Quick, null))), updating && meetingType !== 'Zoom' && /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__invite-item_NEW"
  }, /*#__PURE__*/React.createElement("div", null, !!timeOnDrop.length && formatTimeOnDrop(timeOnDrop) !== schedule.timeslots[0].time.start ? /*#__PURE__*/React.createElement(React.Fragment, null, "Update meeting to ", /*#__PURE__*/React.createElement("span", {
    className: "fw900"
  }, timeOnDrop)) : /*#__PURE__*/React.createElement(React.Fragment, null, " Update meeting ")), /*#__PURE__*/React.createElement("div", {
    className: "flexActions"
  }, /*#__PURE__*/React.createElement(Quick, null))), haveZoomMeeting && !sendZoomUpdate && meetingType === 'Zoom' && /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__invite-item_NEW"
  }, /*#__PURE__*/React.createElement("div", null, "Zoom meeting is created and takes place on", ' ', formatDateTime(availabilityStore.persistedScheduleInfo.zoomMeeting.start_time)), !updating && /*#__PURE__*/React.createElement("div", {
    className: "flexActions"
  }, /*#__PURE__*/React.createElement(Modify, null))), !haveZoomMeeting && sendZoomUpdate && (updating || currentDuration !== duration) && meetingType === 'Zoom' && /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__invite-item_NEW"
  }, /*#__PURE__*/React.createElement("div", null, currentDuration !== duration || updating ? /*#__PURE__*/React.createElement("div", null, !!timeOnDrop.length && formatTimeOnDrop(timeOnDrop) !== schedule.timeslots[0].time.start ? /*#__PURE__*/React.createElement(React.Fragment, null, "Update meeting to", ' ', /*#__PURE__*/React.createElement("span", {
    className: "fw900"
  }, timeOnDrop)) : /*#__PURE__*/React.createElement(React.Fragment, null, " Update meeting ")) : /*#__PURE__*/React.createElement(React.Fragment, null, " Zoom Update")), /*#__PURE__*/React.createElement("div", {
    className: "flexActions"
  }, /*#__PURE__*/React.createElement(Quick, null))), !haveZoomMeeting && currentPath === 'overview', /*#__PURE__*/React.createElement(RenderExpertAction, {
    checkbox: true
  }), /*#__PURE__*/React.createElement(RenderClientAction, {
    checkbox: true
  })));
};

export default ZoomContainer;